import { DATABASE_NAME, DATABASE_VERSION, canonicalString, readSession, validateSnapshot } from './contract';

let connection;
export function openDesktopDatabase() {
  if (connection) return connection;
  connection = new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
    request.onupgradeneeded = () => {
      request.result.createObjectStore('session', { keyPath: 'companyId' });
      request.result.createObjectStore('companySnapshots', { keyPath: 'companyId' });
    };
    request.onsuccess = () => {
      const database = request.result;
      database.onversionchange = () => { database.close(); connection = null; };
      database.onclose = () => { connection = null; };
      resolve(database);
    };
    request.onerror = () => { connection = null; reject(request.error); };
    request.onblocked = () => console.warn('MenuCheff Desktop: banco aguardando outra conexão.');
  }).catch((error) => { connection = null; throw error; });
  return connection;
}

function sameSession(left, right) {
  return canonicalString(left) === canonicalString(right);
}

/** Checks credentials inside the transaction so late HTTP results cannot revive a logout. */
export async function publishDesktopState(session, snapshot = null) {
  if (snapshot) validateSnapshot(snapshot);
  const database = await openDesktopDatabase();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(['session', 'companySnapshots'], 'readwrite');
    const sessions = transaction.objectStore('session');
    const snapshots = transaction.objectStore('companySnapshots');
    let revision = null;
    const currentRequest = sessions.getAll();
    currentRequest.onsuccess = () => {
      const current = readSession();
      if (!sameSession(current, session)) return;
      if (!session) {
        if (currentRequest.result.length) sessions.clear();
        return;
      }
      const previous = currentRequest.result.find((item) => item.companyId === session.companyId);
      const previousSession = previous && { companyId: previous.companyId, token: previous.token,
        userEncoded: previous.userEncoded, user: previous.user };
      if (!sameSession(previousSession, session) || currentRequest.result.length !== 1) {
        sessions.clear();
        sessions.put({ ...session, updatedAt: new Date().toISOString() });
      }
      if (!snapshot) return;
      if (snapshot.companyId !== session.companyId) { transaction.abort(); return; }
      const previousRequest = snapshots.get(session.companyId);
      previousRequest.onsuccess = () => {
        // A logout can happen while the transaction is waiting on this request.
        if (!sameSession(readSession(), session)) { transaction.abort(); return; }
        const previousSnapshot = previousRequest.result;
        const content = { ...snapshot, schemaVersion: 1 };
        const previousContent = previousSnapshot && { ...previousSnapshot };
        if (previousContent) {
          delete previousContent.revision;
          delete previousContent.syncedAt;
          delete previousContent.complete;
        }
        if (previousSnapshot?.complete === true && canonicalString(previousContent) === canonicalString(content)) {
          revision = previousSnapshot.revision;
          return;
        }
        revision = (previousSnapshot?.revision || 0) + 1;
        snapshots.put({ ...content, revision, syncedAt: new Date().toISOString(), complete: true });
      };
    };
    transaction.oncomplete = () => {
      if (revision !== null) window.dispatchEvent(new CustomEvent('menucheff:desktop-synced', {
        detail: { companyId: session.companyId, revision },
      }));
      resolve(revision);
    };
    transaction.onabort = () => reject(transaction.error || new Error('Publicação cancelada'));
  });
}
